
  import { Vue, Component, Prop } from "vue-property-decorator";
  import { Contractor_Rating_Aggregate } from "@/generated/graphql";
  import { getContractorRating } from "@/helpers/contractors/getContractorRating";
  import RatingStars from "@/components/rating/RatingStars.vue";

  @Component({
    components: {
      RatingStars,
    },
  })
  export default class CardRating extends Vue {
    @Prop({ type: Object, required: true }) readonly ratingTotal!: Contractor_Rating_Aggregate;

    get rating(): number {
      return getContractorRating(this.ratingTotal);
    }
  }
